import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { register, kycToken, kycStatus, update, contract, sign, checkEmail, auth, confirmBitpos, getContract, updatePhone } from '../services/users'

function parsePhoneNumber(phone) {
    if (!phone) return ["", ""];
    
    // eliminar espacios y "+"
    let cleanPhone = phone.replace(/\s+/g, "").replace("+", "");
    // asumir que la extensión siempre son los primeros 3 dígitos
    const extensionNumber = cleanPhone.slice(0, 3);
    const phoneNumber = cleanPhone.slice(3);

    return [extensionNumber, phoneNumber];
}

// REGISTER A NEW USER
export const registerUser = createAsyncThunk('user/register', async (args, { getState }) => {
    const { user } = getState();
    const response = await register({
        correo: user.email.value,
        password: user.password.value,
        "password-2": user.password.value,
        first_name: "NONE",
        last_name: "NONE"
    });
    return { response: response.data, statusCode: response.status };
});

// REGISTER A NEW USER
export const authUser = createAsyncThunk('user/auth', async (args, { getState }) => {
    const { user } = getState();
    const response = await auth({
        correo: user.email.value,
        password: user.password.value
    });
    return { response: response.data, statusCode: response.status };
});

// UPDATE USER DATA
export const updateUser = createAsyncThunk('user/update', async (args, { getState }) => {
    const { user } = getState();
    const response = await update({ uid: user.id });
    return { response: response.data, statusCode: response.status };
});

// GENERATE CONTRACT
export const generateContract = createAsyncThunk('user/contract', async (args, { getState }) => {
    const { user } = getState();
    const response = await contract({
        email: user.email.value,
        phoneNumber: `+${user.phone.extension} ${user.phone.number}`
    });
    return { response: response.data, statusCode: response.status };
});

// SIGN CONTRACT
export const signContract = createAsyncThunk('user/sign', async (args, { getState }) => {
    const { user } = getState();
    const response = await sign({
        email: user.email.value,
        secret: args.code
    });
    return { response: response.data, statusCode: response.status };
});

// RETRIEVE THE TOKEN FOR SUMSUB VALIDATION
export const getKYCToken = createAsyncThunk('user/kycToken', async (args, { getState }) => {
    const { user } = getState();
    const response = await kycToken({ email: user.email.value });
    return { response: response.data, statusCode: response.status };
});

// RETRIEVE THE USERS KYC STATUS
export const getKYCStatus = createAsyncThunk('user/kyc', async (args, { getState }) => {
    const { user } = getState();
    const response = await kycStatus({ email: user.email.value });
    return { response: response.data, statusCode: response.status };
});

// CHECK FOR USER EMAIL
export const checkForUser = createAsyncThunk('user/check', async (args, { getState }) => {
    const { user } = getState();
    const response = await checkEmail({ email: user.email.value });
    return { response: response.data, statusCode: response.status };
});

// GENERATE CONTRACT
export const getOneShotContract = createAsyncThunk('user/getContract', async (args, { getState }) => {
    const { user } = getState();
    const response = await getContract({
        id: user.id,
        client: user.client
    });
    return { response: response.data, statusCode: response.status };
});

// UPDATE USER PHONE NUMBER
export const updateUserPhoneNumber = createAsyncThunk('user/updatePhone', async (args, { getState }) => {
    const { user } = getState();
    const response = await updatePhone({
        id: user.id,
        phoneNumber: `+${user.phone.extension} ${user.phone.number}`
    });
    return { response: response.data, statusCode: response.status };
});

// REGISTER BITPOS
export const registerBitpos = createAsyncThunk('user/registerBitpos', async (args, { getState }) => {
    const { user, bussines, bank, blockchain } = getState();
    const response = await confirmBitpos({
        "action": args["storeID"] ? "update" : "create",
        "StoreID": args["storeID"],
        "UserID": user.id,
        "NIT": bank.nit.value,
        "BussinesName": bussines.name.value,
        "BussinesType": bussines.type.value,
        "PointsOfSale": bussines.pointsOfSale.value,
        "Currency": bussines.currency.value,
        "Country": user.country.value,
        "PaymentMethod": bussines.paymentType,
        "UserInfo": {
            "First_Name": "",
            "Last_Name": "",
            "Email": user.email.value,
            "Phone": `+${user.phone.extension.replace("+", "")} ${user.phone.number}`,
        },
        "PaymentInfo": bussines.paymentType === "FIAT" ? {
            "NIT": bank.nit.value,
            "Bank_Name": bank.bankName.value,
            "Swift_Code": "1",//bank.swiftCode.value,
            "Bank_Account_Name": bank.accountName.value,
            "Bank_Account_Type": bank.accountType.value,
            "Bank_Account_Number": bank.accountNumber.value,
            "Bank_Account_Currency": bank.accountCurrency.value,
        } : {
            "Alias": blockchain.alias.value,
            "Crypto": blockchain.crypto.value,
            "Wallet": blockchain.address.value,
            "Network": blockchain.network.value,
        },
    });
    return { response: response.data, statusCode: response.status };
});


export const userSlice = createSlice({
    name: 'user',
    initialState: {
        id: null,
        kyc: "none",
        exists: false,
        oneshot: null,
        client: {},
        phone: { error: false },
        country: { value: "", error: true },
        email: { value: "", error: true },
        password: { value: "", error: true, checks: {} },
    },
    reducers: {
        setEmail: (state, action) => { state.email = action.payload },
        setPhone: (state, action) => { state.phone = action.payload },
        setCountry: (state, action) => { state.country = action.payload },
        setPassword: (state, action) => { state.password = action.payload },
    },
    extraReducers: builder => {
        builder
            // registerUser REDUCER
            .addCase(registerUser.fulfilled, (state, { payload }) => {
                const { response } = payload;
                if (response.ok && !response.user.error) { state.id = response.user.user.uid; }
            })
            .addCase(registerUser.rejected, (state, action) => { state.id = null; })
            // registerUser REDUCER
            .addCase(authUser.fulfilled, (state, { payload }) => {
                const { response } = payload;
                //VALIDATION EXTENSION NUMBER PHONE
                const phoneUser = parsePhoneNumber(response.phone);
                
                if (!response.error) {
                    state.id = response.uid;
                    state.kyc = response.kyc;
                    state.oneshot = response.oneshot;
                    state.phone.extension =  phoneUser[0] || "";
                    state.phone.number = phoneUser[1] || "";
                    state.client = response.client;
                }
            })
            .addCase(authUser.rejected, (state, action) => { state.id = null; })
            // checkForUser REDUCER
            .addCase(checkForUser.fulfilled, (state, { payload }) => {
                const { response } = payload;
                if (response.statusCode === 200) state.exists = true;
                else state.exists = false;
            })
            .addCase(checkForUser.rejected, (state) => { state.exists = false; })
    }
})

// Action creators are generated for each case reducer function
export const { setEmail, setPassword, setPhone, setCountry } = userSlice.actions
export default userSlice.reducer